import styled, { css } from "styled-components";

interface SwitchButtonStyleProps {
  $value: boolean;
}

export const SwitchButton = styled.button`
  border: none;
  height: 54px;
  display: flex;
  background: none;
  align-items: center;
  justify-content: center;
`;

export const SwitchIndicator = styled.div<SwitchButtonStyleProps>`
  width: 54px;
  height: 24px;
  position: relative;
  transition: background 0.1s ease-out;
  background: ${(props) =>
    props.$value === true
      ? props.theme.colors.primary100
      : props.theme.colors.black12};
  border-radius: 12px;
`;

export const SwitchToggle = styled.div<SwitchButtonStyleProps>`
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  position: absolute;
  background: ${(props) => props.theme.colors.white100};
  transition: all 0.1s ease-out;
  border-radius: 50%;

  ${(props) =>
    props.$value === true &&
    css`
      transform: translateX(30px);
    `}
`;

export const Label = styled.span<SwitchButtonStyleProps>`
  top: 6px;
  color: ${(props) => props.theme.colors.white100};
  position: absolute;

  ${(props) =>
    props.$value === true &&
    css`
      left: 9px;
    `}

  ${(props) =>
    props.$value === false &&
    css`
      right: 9px;
    `}
`;
